import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class BenefitEmployee  {
    _originalTypeClassName = "zERP.BO.BenefitEmployee";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
BenefitEmployee.translate = translateService;
}
this.lstBenefitValue = [];
this.Id = null;
this.EffectiveFrom = null;
this.EffectiveTo = null;
this.Comments = null;
this.Amount = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
EffectiveFrom:any;
EffectiveTo:any;
Comments:any;
Amount:any;
BenefitType:any;
EmployeeContract:any;
lstBenefitValue:any;
Employee:any;
static setBenefitType = ($this, value) => {
var oldValue = $this.BenefitType;
$this.BenefitType = value;
if (value != null) {
}
}
static setEmployeeContract = ($this, value) => {
var oldValue = $this.EmployeeContract;
$this.EmployeeContract = value;
if (value != null) {
}
}
static setlstBenefitValue = ($this, items) => {
                if (items == null) items = [];
                if ($this.lstBenefitValue == null) $this.lstBenefitValue = [];

                const copyItems = Common.cloneObject(items);

                while ($this.lstBenefitValue.length > 0) {
                    Domain.BenefitEmployee.removelstBenefitValue($this, $this.lstBenefitValue[0]);
                }

                Domain.BenefitEmployee.addManylstBenefitValue($this, copyItems);
            }
static addManylstBenefitValue = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.BenefitEmployee.addlstBenefitValue($this, items[i]);
                }
            }
static addlstBenefitValue = ($this, item) => {
                if ($this.lstBenefitValue == null) $this.lstBenefitValue = [];
                if (item == null || $this.lstBenefitValue.indexOf(item) > -1) return;
                $this.lstBenefitValue.push(item);
}
static addRangelstBenefitValue = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.BenefitEmployee.addlstBenefitValue($this, item));
            }
static removelstBenefitValue = ($this, item) => {
                if ($this == null || $this.lstBenefitValue == null || $this.lstBenefitValue.indexOf(item) === -1) return;
                var _index = $this.lstBenefitValue.indexOf(item);
                $this.lstBenefitValue.splice(_index, 1);
}
static clearlstBenefitValue = ($this) => { $this.lstBenefitValue = null; }
static setEmployee = ($this, value) => {
var oldValue = $this.Employee;
$this.Employee = value;
if (value != null) {
}
}

static BenefitValueDynamicColumnValues(be: any): any{let values = [];
for (let _ibv = 0; _ibv < (be?.lstBenefitValue == null ? 0 : be?.lstBenefitValue.length); _ibv++) {let bv = be?.lstBenefitValue[_ibv];let benefitValueName = new ListDynamicColumnValue();benefitValueName.dynamicValue = bv?.Name;values?.add(benefitValueName);switch (bv?.DataType) {case Domain.DataType.Logic:
{
let benefitValue = new ListDynamicColumnValue();benefitValue.dynamicValue = bv?.bValue;values?.add(benefitValue);break;}
case Domain.DataType.Date:
case Domain.DataType.DateTime:
case Domain.DataType.Time:
{
let benefitValue = new ListDynamicColumnValue();benefitValue.dynamicValue = bv?.dtValue;values?.add(benefitValue);break;}
case Domain.DataType.Integer:
case Domain.DataType.Duration:
{
let benefitValue = new ListDynamicColumnValue();benefitValue.dynamicValue = bv?.nValue;values?.add(benefitValue);break;}
case Domain.DataType.Numeric:
case Domain.DataType.Money:
{
let benefitValue = new ListDynamicColumnValue();benefitValue.dynamicValue = bv?.fValue;values?.add(benefitValue);break;}
default:
{
let benefitValue = new ListDynamicColumnValue();benefitValue.dynamicValue = bv?.strValue;values?.add(benefitValue);break;}
}}
return values;
}
static GetAllSubDepartments(department: any,departmentIdList: any): any{departmentIdList?.add(department?.Id);
if ((department?.Children != null && CLMS.Framework.Number.GreaterThan(() => department.Children.length, () => 0))) {for (let _ichild = 0; _ichild < (department?.Children == null ? 0 : department?.Children.length); _ichild++) {let child = department?.Children[_ichild];Domain.BenefitEmployee.GetAllSubDepartments(child, departmentIdList);}}
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}